// extracted by mini-css-extract-plugin
module.exports = {"editableCellInputNumber":"EditableCell_editableCellInputNumber__3q7fY"};